// extracted by mini-css-extract-plugin
module.exports = {"container":"Patients_container__2wHJv","create":"Patients_create__3fYh5"};